import React from 'react';
import Fade from 'react-reveal/Fade';
import bannerleft from '../Assets/bannerleft.png'
import kit from '../Assets/kit.png'

const About1 = () => {
  return (
    <div className="about-section-container">
      <Fade left>
      <div className="about-background-image-container">
        <img src={bannerleft} alt="" />
      </div>
      <div className="about-section-image-container">
        <img className='image' src={kit} alt="" />
      </div>
      </Fade>
      <div className="about-section-text-container">
      <Fade right>
        <h1 className="product-primary-heading">
          Sustainability Starter Kit
        </h1>
        <p className="feature-primary-text">
        <b>Consists of :</b> <hr /> 2 Bamboo Straws,1 Plant Based Reusable Cup with 2 lids,1 Natural Loofah,1 box of 50 Bamboo Cotton Eartips,1 Bamboo Toothbrush
        </p>
        <p className="product-primary-text">
          €10.99
        </p>
      </Fade>
      <Fade bottom>
        <div className="about-buttons-container">
          <button className="secondary-button">Buy Now</button>
        </div>
      </Fade>
      </div>
    </div>
    
  )
}

export default About1;